import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
// styles
import { IconTextTooltipStyles } from "./iconTextTooltip.styles";

const IconTextTooltip = ({
  Icon,
  text,
  isTooltipVisible,
  isTextVisible,
  tooltipContent,
  tooltipUpperContent,
  style,
  id
}) => {
  return (
    <IconTextTooltipStyles style={{ ...style }}>
      <button
        className="iconContainer"
        style={{ cursor: isTooltipVisible && "pointer" }}
        data-tooltip-id={id}
      >
        <Icon />
      </button>
      {isTextVisible && <p className="text">{text}</p>}
      {isTooltipVisible && (
        <Tooltip
          className="tooltip"
          id={id}
          render={() => (
            <>
              {tooltipUpperContent && (
                <p className="tooltipText">{tooltipUpperContent}</p>
              )}
              <p className="tooltipText">{tooltipContent}</p>
            </>
          )}
        />
      )}
    </IconTextTooltipStyles>
  );
};

export default IconTextTooltip;
